module.exports = __webpack_public_path__ + "static/media/third-step.246f539c.png";